import { render, staticRenderFns } from "./ConversationImage.vue?vue&type=template&id=6643af4c&scoped=true"
import script from "./ConversationImage.vue?vue&type=script&lang=js"
export * from "./ConversationImage.vue?vue&type=script&lang=js"
import style0 from "./ConversationImage.vue?vue&type=style&index=0&id=6643af4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6643af4c",
  null
  
)

export default component.exports